/**
 * CRUD for handling the `steps` state object
 */
import {
  mapBranchedSteps,
  arrayFromGraph,
  formatRequestBodyGraph,
  createDelayNode,
  isDelayNode,
  isContinuousStatusCheckNode
} from 'components/scenarios/utils/graph'
import { isLastIndex } from 'utils/list'

/** Sort, reorder, and format steps
 *
 * @param {Array} steps
 * @returns {Array}
 */
export function reformatSteps(steps) {
  try {
    return mapBranchedSteps(arrayFromGraph(formatRequestBodyGraph(steps)))
  } catch {
    return reformatSteps(mapBranchedSteps(arrayFromGraph(steps)))
  }
}

/** Add a new step to a steps list
 *
 * @param {Array} steps
 * @param {Object} newStep
 * @returns {Array}
 */
export function addStep(steps, newStep) {
  let newSteps = [...steps]

  if (
    newSteps.length > 0 &&
    !isContinuousStatusCheckNode(newStep) &&
    !isContinuousStatusCheckNode(steps[steps.length - 1])
  ) {
    newSteps.push(createDelayNode())
  }
  newSteps.push(newStep)

  return reformatSteps(newSteps)
}

/** Update steps array with edited step and any delay node updates necessary
 *
 * @param {Array} steps
 * @param {int} index
 * @param {Object} editedStep
 * @returns {Array}
 */
export function editStep(steps, index, editedStep) {
  const newSteps = [...steps]
  newSteps[index] = editedStep

  // Add delay node if converting from continuous to synchronous status check
  if (
    !isContinuousStatusCheckNode(editedStep) &&
    !isDelayNode(newSteps[index + 1])
  ) {
    newSteps.splice(index + 1, 0, createDelayNode())
  } else if (
    isContinuousStatusCheckNode(editedStep) &&
    isDelayNode(newSteps[index + 1])
  ) {
    newSteps.splice(index + 1, 1)
  }

  return reformatSteps(newSteps)
}

/** Delete a step and any delay nodes necessary from steps array
 *
 * @param {*} steps
 * @param {*} index
 * @returns {Array}
 */
export function deleteStep(steps, index) {
  let newSteps = [...steps]
  let newIndex = index

  // If we're removing the last step,
  if (isLastIndex(newSteps, newIndex)) {
    // We should delete the delay before it
    if (isDelayNode(newSteps[newIndex - 1])) {
      newSteps.splice(newIndex - 1, 1)
      newIndex--
    }
  }

  // If the next node is a Delay, remove it as well
  if (isDelayNode(newSteps[newIndex + 1])) {
    newSteps.splice(newIndex + 1, 1)
  }

  // Remove the node
  newSteps.splice(newIndex, 1)

  return reformatSteps(newSteps)
}

export function upsertStep({ steps, node, index }) {
  // because `index: 0` will return false, we check for that
  return index || index === 0
    ? editStep(steps, index, node)
    : addStep(steps, node)
}
